import { useState, useEffect } from "react";
import moment from "moment";
import Countdown from "../../countdown/countdown.component";
import WizardModal from "../../wizard-modal/wizard-modal.component";
import WizardModalStep from "../../wizard-modal/wizard-modal-step/wizard-modal-step.component";
import MakeOffer from "../make-offer/make-offer";
import ConfirmBid from "../confirm-bid/confirm-bid";
import OrderConfirmed from "../order-confirmed/order-confirmed";
import FundsBid from "../insufficient-funds/funds-bid";
import PaymentMethod from "../payment-method/payment-method";
import VisaFunds from "../visa-funds/visa-funds";
import TransactionSuccess from "../transaction-success/transaction-success";
import { ReactComponent as CloseIcon } from "../../../icons/close.svg";
import {
  CMCloseButton,
  CMwizardMakeOffer,
  CMTitleStyle,
  CMwizardConfirmBid,
  CMwizardOrderConfirmed,
  CMwizardFundsBid,
  CMwizardPaymentMethod,
  CMwizardVisaFunds,
  CMwizardTransactionSuccess,
  CMwizardAuctionBook,
  CMModalAuctionBook,
  CMWarning,
  CMTitleStyleMobile,
} from "./place-bid.styles";
import AuctionBook from "../auction-book/auction-book";
import { useParams } from "react-router-dom";
import { Form,Formik } from "formik";
import { useAuth } from "../../../Contexts/auth.context";
import { bid_Add } from "../../../Services/auction.service";
import { getWalletBalance } from "../../../Services/prod/auth.service";
import TransactionFailure from "../transaction-failure/transaction-failure";
import { formatCommaNumbers } from "../../../Utils/common.utils";
import WizardModalMakeOffer from "../../wizard-modal-makeoffer/wizard-modal-makeoffer.component";
import { useMediaQuery } from "@mui/material";
import WizardModalOrderSubmitted from "../../wizard-modal/wizard-modal-order-submitted/wizard-modal-order-subbmited.component";
import WizardModal2 from "../../wizard-modal/wizard-modal.component2";

const initialValues = {
  bidPerUnit: 0,
  totalUnit: 0,
  dollar: '$'
}

const PlaceBid = ({ open, handleClose, openStep, refresh, orderConfirm ,values,auction,setAuction,setRefreshDetailsPage,refreshDetailsPage,endDate}) => {
  // Get value from Auction - Card When Click Make an Offer Button
  const [fundsInValet, setFundsInValet] = useState(orderConfirm);
  const [activeStep, setActiveStep] = useState(openStep);
  const [balance, setBalance] = useState("");
  const [balanceFee, setBalanceFee] = useState("");
  const [fundsResponse, setFundsResponse] = useState("");
  const [balanceFeeFormatted, setBalanceFeeFormatted] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const isMobile = useMediaQuery("(max-width:767px)");

  useEffect(() => {
    setActiveStep(openStep);
    setFundsInValet(orderConfirm);
  }, [refresh]);

  const handleNext = () => {
    if (fundsInValet === false) {
      // When click make an offer to go to Insufficient funds Screen
      setActiveStep((value) => value + 3);
      setFundsInValet(!fundsInValet);
      return;
    }
    // When click make an offer to go to  Confirm Bid  Screen
    setActiveStep((value) => value + 1);
  };
  
  const handleOffer = () => {
    setActiveStep(0);
    //setFundsInValet(false);
  };

  const handlePrev = () => {
    setActiveStep((value) => value - 1);
  };

  const handleClosed = () => {
    setActiveStep(0);
    setFundsInValet(true);
    handleClose(); // Set a value that indicates the wizard is closed
  };

  const transhandleClosed = () => {
    setActiveStep(0);
    setFundsInValet(false);
    handleClose();
  };

  
  const getBalance = async () => {  
    try {
        const walletRes = await getWalletBalance();
        const newBalance = walletRes?.data;
        setBalance(newBalance[0]?.available_cash);
        setBalanceFee(newBalance[0]?.fees.bid_fee);
    } catch (error) {
        console.log(error, "error");
    }
  };

  useEffect(()=>{
    getBalance();
  },[]);

  const formatBalance = (balance) => {
    try {
      const formatted = parseFloat(balance).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      return formatted
    }
    catch (e){
      return balance
    }
  }

  return (
    <>
      <WizardModal2 open={open} onClose={handleClose}>
        <CMCloseButton onClick={handleClosed}>
          <CloseIcon width={16} height={16} />
        </CMCloseButton>
       <Formik
        initialValues={initialValues}
        onSubmit={()=>console.log(values)}
       >
         {({ values, errors, touched }) => (
          <Form>
            {
            {
              0: (
                <CMModalAuctionBook   style={{overflowX:'hidden'}}>
                <WizardModalMakeOffer
                  style={CMwizardMakeOffer}
                  title={<Countdown date={endDate}/>}
                >
                  <div>
                      <MakeOffer handleNext={handleNext} setActiveStep={setActiveStep} values={values} handleClose={handleClose} balance={balance} balanceFee={balanceFee}/>
                  </div>
                </WizardModalMakeOffer>
                </CMModalAuctionBook>
              ),
              1: (
                <WizardModalStep
                  sx={{
                    width: 673,
                    '@media (min-width: 2000px)': {
                      width: '100%',
                    },
                  }}
                  title={<Countdown date={endDate} />}
                >
                  <div>
                    <ConfirmBid auction={auction} setAuction={setAuction} setActiveStep={setActiveStep}  handlePrev={handlePrev} values={values} setRefreshDetailsPage={setRefreshDetailsPage} refreshDetailsPage={refreshDetailsPage} balanceFee={balanceFee} setBalanceFeeFormatted={setBalanceFeeFormatted} setWarningMessage={setWarningMessage}/>
                  </div>
                </WizardModalStep>
              ),
              2: (
                <WizardModalOrderSubmitted
                  title="Order Submitted"
                  style={CMwizardOrderConfirmed}
                  titleStyle={CMTitleStyle}
                  orderSubmitted={true}
                >
                  <OrderConfirmed
                    handleNext={handleClosed}
                    orderText="Your order has been placed successfully!"
                    orderInform={`Amount of ${balanceFeeFormatted} of your Available Cash had been temporarily restricted to support your bid until auction completion.`}
                    orderInform2={`Your total Cash Balance will be debited only if your bid will be defined as part of the winning bids, and and once your portfolio will be credited with the appropriate purchased units.`}
                    linkText="/portfolio"
                    balance={balance}
                    totalBid={values.totalBid}
                    balanceFee={balanceFee}
                  />
                </WizardModalOrderSubmitted>
              ),
              3: (
                <WizardModalStep
                  title="Insufficient Funds"
                  style={CMwizardFundsBid}
                  titleStyle={CMTitleStyle}
                >
                  <div>
                    <FundsBid
                      setActiveStep={setActiveStep}
                      handleClose={handleClose}
                      setFundsResponse={setFundsResponse}
                      addFunds={`Looks like you only have ${formatBalance(balance)} on your account. Would you like to add some funds now?`}
                    />
                  </div>
                </WizardModalStep>
              ),
              4: (
                <WizardModalStep
                  title="Choose your payment method"
                  style={CMwizardPaymentMethod}
                  titleStyle={CMTitleStyle}
                >
                  <div>
                    <PaymentMethod
                      handleNext={handleNext}
                      handlePrev={handlePrev}
                      title="Credit and debit cards"
                      subtitle="Fastest transaction"
                      visaCard="VisaCard.png"
                      masterCard="MasterCard_Logo.png"
                      bankTransfer="BankTransfer"
                      bankTransferSubtitle="Wire transfer from your bank or provider"
                    />
                  </div>
                </WizardModalStep>
              ),
              5: (
                <WizardModalStep
                  title="Add Funds"
                  style={CMwizardVisaFunds}
                  titleStyle={CMTitleStyle}
                >
                  <div>
                    <VisaFunds
                      handleNext={handleNext}
                      handlePrev={handlePrev}
                      visaCard="VisaCard.png"
                      footer="A transaction fee of $0.20 from the payment provider will be added to this amount"
                    />
                  </div>
                </WizardModalStep>
              ),
  
              6: (
                <WizardModalStep
                  title="Transaction Successful"
                  style={CMwizardTransactionSuccess}
                  titleStyle={CMTitleStyle}
                >
                  <div>
                    <TransactionSuccess
                      handleNext={transhandleClosed}
                      information={`The funds of $${formatCommaNumbers(fundsResponse)} have been credited to your account`}
                    />
                  </div>
                </WizardModalStep>
              ),
              7: (
                <CMModalAuctionBook>
                  <WizardModalStep
                  title="Auction Book"
                  style={CMwizardAuctionBook}
                  titleStyle={isMobile ? CMTitleStyleMobile : CMTitleStyle}
                >
                  <div>
                    <AuctionBook
                      handleNext={handleOffer}
                      handleClose={transhandleClosed}
                      information="Auction Book"
                      auction={auction}
                    />
                  </div>
                </WizardModalStep>
                </CMModalAuctionBook>
                
              ),
              8: (
                <WizardModalStep
                  title="Error"
                  style={CMWarning}
                  titleStyle={CMTitleStyle}
                >
                  <div>
                     <TransactionFailure
                      information={`${warningMessage}`}
                    />
                  </div>
                </WizardModalStep>
              ),
            }[activeStep]
          }
          </Form>
          )}
        </Formik>
      </WizardModal2>
    </>
  );
};
export default PlaceBid;
